import { useEffect, useState } from 'react';
import { useWidgetDndContextData } from 'src/context/WidgetDndContext';
import { useListPresentationContextData } from '../context/ListPresentationContext';
import { SCROLL_TYPE } from '../components/Testimonials/Constants';

export function useAdjustSubWidgetProps({ stopAutoRotation, carouselScrollTo }) {
  const data = useListPresentationContextData();
  const props = data.props;
  const { listPresentationConfig } = data.state;
  const {
    widgetContextState: { activeWidgetId, widgets },
  } = useWidgetDndContextData();

  const [oldScrolType, setOldScrollType] = useState(null);

  const activeSubwidgetIndex = widgets?.[activeWidgetId]?.props?.subWidgetIndex;
  const isSubwidgetSelected = props?.id === activeWidgetId && activeSubwidgetIndex !== -1;

  useEffect(() => {
    if (isSubwidgetSelected) {
      setOldScrollType(listPresentationConfig?.autoPlayConfig?.type);
      adjustWidgetProps();
      scrollToActiveSubwidget();
      stopAutoRotation();
    } else {
      removeAdjustedPropChange();
    }
  }, [isSubwidgetSelected]);

  function adjustWidgetProps() {
    if (listPresentationConfig?.autoPlayConfig?.type) {
      listPresentationConfig.autoPlayConfig.type = SCROLL_TYPE.MANUAL;
    }
  }

  function removeAdjustedPropChange() {
    if (listPresentationConfig?.autoPlayConfig?.type && oldScrolType) {
      listPresentationConfig.autoPlayConfig.type = oldScrolType;
      setOldScrollType(null);
    }
  }

  function scrollToActiveSubwidget() {
    setTimeout(() => carouselScrollTo(activeSubwidgetIndex), 0);
  }

  return null;
}
